enum TagAccent {
    /** GuxTag accent default value for Flare theme */
    FLARE = "1",
    /** GuxTag accent default value for legacy theme */
    LEGACY = "4",
}

export default TagAccent;
